import { render, staticRenderFns } from "./Responsibilities.vue?vue&type=template&id=65e3a32a&scoped=true&lang=pug"
import script from "./Responsibilities.vue?vue&type=script&lang=js"
export * from "./Responsibilities.vue?vue&type=script&lang=js"
import style0 from "./Responsibilities.vue?vue&type=style&index=0&id=65e3a32a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e3a32a",
  null
  
)

export default component.exports